// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox__Checkbox_2fE_b"};